import { createSelector } from 'reselect';
import { isTakenSeriesCompleted, isTakenSeriesInProgress } from './utils';

export const getSeriesTakenInSession = state => state.series.takenSeries;

export const getCompletedSeries = createSelector(
  state => state.series.takenSeries,
  takenSeries =>
    Object.keys(takenSeries).filter(id =>
      isTakenSeriesCompleted(takenSeries[id]),
    ),
);

export const getTakenSeriesProcessing = state =>
  state.series.takenSeriesProcessing;

export const getInProgressSeries = createSelector(
  state => state.series.takenSeries,
  takenSeries =>
    Object.keys(takenSeries).filter(id =>
      isTakenSeriesInProgress(takenSeries[id]),
    ),
);
